import { render, staticRenderFns } from "./SetSalesTaxRate.vue?vue&type=template&id=5e236bbe"
import script from "./SetSalesTaxRate.vue?vue&type=script&lang=js"
export * from "./SetSalesTaxRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports